
<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="type-modal">
    <div class="card" [formGroup]="organizationForm" style="padding-bottom: 12px;">
      <h3 class="green decoration mb-4">Detalles del acuerdo comercial</h3>
      <!--
      <div class="form-wrapper" [class.control-invalid]="organizationForm.get('organization_id').dirty && organizationForm.get('organization_id').invalid">
        <span>Producto</span>
        <input type="text" formControlName="product" [attr.disabled]="true">
        <p *ngIf="organizationForm.get('organization_id').dirty && organizationForm.get('organization_id').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="organizationForm.get('organization_id').errors.required">Este campo es necesario</label>
        </p>
      </div>
       <div class="form-wrapper mb-3" [class.control-invalid]="organizationForm.get('charge_frequency').dirty && organizationForm.get('charge_frequency').invalid">
        <span>Frecuencia de cobro</span>
        <select formControlName="charge_frequency" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let charge of charges" [value]="charge.value">{{ charge.name }}</option>
        </select>
        <p *ngIf="organizationForm.get('charge_frequency').dirty && organizationForm.get('charge_frequency').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="organizationForm.get('charge_frequency').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="organizationForm.get('trial_end').dirty && organizationForm.get('trial_end').invalid">
        <span>Periodo de prueba</span>
        <input type="date" formControlName="trial_end" [attr.disabled]="true">
        <p *ngIf="organizationForm.get('trial_end').dirty && organizationForm.get('trial_end').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="organizationForm.get('trial_end').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-wrapper mb-3">
            <span>Correo Electrónico</span>
            <input type="mail" formControlName="organization_email" [attr.disabled]="true">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-wrapper mb-3">
            <span>Etiqueta de negocio</span>
            <input type="text" formControlName="organization_label" [attr.disabled]="true">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-wrapper mb-3">
            <span>Teléfono del negocio</span>
            <input type="string" formControlName="organization_phone" [attr.disabled]="true">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-wrapper mb-3">
            <span>Cliente</span>
            <input type="text" formControlName="organization_name_contact" [attr.disabled]="true">
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-wrapper mb-3">
            <span>Ciudad</span>
            <input type="text" formControlName="organization_city" [attr.disabled]="true">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-wrapper">
            <span>Zona</span>
            <input type="text" formControlName="organization_zone" [attr.disabled]="true">
          </div>
        </div>
      </div> -->
    </div>
    <div class="card" style="padding-top: 12px;">
      <h3 class="green decoration mb-4">Productos / Servicios añadidos</h3>
      <app-custom-table-min [displayedColumns]="displayedColumns" [data]="dataSource" [customH]="'custom-1'" (eventSendActualData)="updateData($event)"></app-custom-table-min>
      <!-- <button class="btn btn-primary big" (click)="addtradeAgreement()">Añadir producto</button> -->

      <!-- <h3 class="green decoration mb-4">Precio Total</h3>
      <div class="flex gap-4 justify-end">
        <div class="form-wrapper mb-3 max-w-[80px]">
          <input type="text" class="text-center" placeholder="--" value="Bs" disabled>
        </div>
        <div class="form-wrapper mb-3 max-w-[180px]">
          <input type="number" class="text-center big" placeholder="--" value="400" disabled>
        </div>
      </div> -->
    </div>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button> -->
        <!-- <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big">Cancelar</button> -->
        <button mat-button type="button" (click)="dismiss()" class="btn btn-primary big">Aceptar</button>
  </div>
</div>
